import React, { useEffect, useState } from 'react';
import ToHomeButton from '../../buttons/ToHomeButton';
import { pendingCount, subscribePending } from '../../../utils/logQueue';

// 送信待ちの記録の件数（ログ送信が無効なら null）。キューが変わるたびと、念のため数秒ごとに読み直す
function usePendingLogCount() {
  const [count, setCount] = useState(() => pendingCount());
  useEffect(() => {
    const unsubscribe = subscribePending(setCount);
    const timer = setInterval(() => setCount(pendingCount()), 2000);
    return () => { unsubscribe(); clearInterval(timer); };
  }, []);
  return count;
}

// 演習の完了画面（形状変更・視点変更で共用）。
// 回答の記録がまだ送り終わっていなければ、画面を閉じないよう促す
// （送信の途中で閉じると、その端末で次にアプリを開くまで届かないため。2026-10-12）。
// 文言は学習者の目線で書く（2026-10-15）：記録の送信は学習者が意図して行う操作ではないので
// 「記録を送る」「件数」は出さず、送り終わるまでは「保存しています」、送り終えたら「終了です」とだけ伝える。
// 【最初からやり直す】は出さない（2026-10-12）：学習者が答え直すと同じ設問の回答が重なり、
// 実験データとして扱いにくくなるため。出口は【Home画面に戻る】だけにする。
export default function ExerciseFinish({ exerciseName }) {
  const pending = usePendingLogCount();
  const saving = pending != null && pending > 0;
  return (
    <div className="page">
      <div className="exercise-finish">
        <p className="exercise-finish__eyebrow">{exerciseName}</p>
        <h1 className="heading-hero mb-6">お疲れ様でした！</h1>
        <p
          className={saving ? 'exercise-finish__send exercise-finish__send--pending' : 'text-middle mb-6'}
          role="status"
        >
          {saving
            ? '回答を保存しています。この画面のまま、少しお待ちください。'
            : `${exerciseName}はすべて終了です！`}
        </p>
        <div className="row-center">
          <ToHomeButton buttonText="Home画面に戻る" />
        </div>
      </div>
    </div>
  );
}
